"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isValidRegNr = exports.ensureEndsWith = exports.ensureStartsWith = void 0;
/**
 * Ensure that a string starts with a specific text.
 *
 * @param text Text to ensure starts with `start`.
 * @param start Text to ensure `text` starts with.
 * @param ignoreCase Ignore case when comparing.
 * @returns A string that starts with `start`.
 */
function ensureStartsWith(text, start, ignoreCase = false) {
    const startsWith = ignoreCase
        ? text.toLowerCase().startsWith(start.toLowerCase())
        : text.startsWith(start);
    return startsWith ? text : `${start}${text}`;
}
exports.ensureStartsWith = ensureStartsWith;
/**
 * Ensure that a string ends with a specific text.
 *
 * @param text Text to ensure ends with `end`.
 * @param end Text to ensure `text` ends with.
 * @param ignoreCase Ignore case when comparing.
 * @returns A string that ends with `end`.
 */
function ensureEndsWith(text, end, ignoreCase = false) {
    const endsWith = ignoreCase
        ? text.toLowerCase().endsWith(end.toLowerCase())
        : text.endsWith(end);
    return endsWith ? text : `${text}${end}`;
}
exports.ensureEndsWith = ensureEndsWith;
/**
 * Test if a string is a valid swedish registration number.
 *
 * @param val Value to test.
 */
function isValidRegNr(val) {
    return /[A-Z]{3}[0-9]{2}[0-9A-Z]/ig.test(val);
}
exports.isValidRegNr = isValidRegNr;
//# sourceMappingURL=strings.js.map